import Reflux from 'reflux';

const AlarmCallbackHistoryActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default AlarmCallbackHistoryActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/alarmcallbacks/AlarmCallbackHistoryActions.js